import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatCardModule } from '@angular/material/card';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-no-permission',
  imports: [TranslateModule, MatCardModule],
  standalone: true,
  templateUrl: './no-permission.component.html',
  styleUrl: './no-permission.component.scss',
})
export class NoPermissionComponent {}
